import React from 'react';
import {isNoU} from "../../../utils/DBUtils";
import {AutoSaveCheckboxOptionsBreakField} from "../Component Sets/MultiPlatformComponents";

{/* We need a custom component to gather the options from a proxy to populate
    a checkbox list with all the steps */
}

const BreakStepCheckboxes = (props) => {

  let steps = props.formProxy.currentBaseResource.steps;
  let stepOptions = [];
  let stepIds = []
  if (!isNoU(steps)) {
    for (let i = 0; i < steps.length; i++) {
      let step = steps[i];
      stepOptions.push({value: step.id, text: step.label ? step.label : step.type});
      stepIds.push(step.id)
    }
  }

//   console.log(props.formProxy.resource)
  let requiredStepIds = []

  for (let platform in props.formProxy.resource) {
      console.log(platform)
      if (props.formProxy.resource[platform] && props.formProxy.resource[platform].requiredStepCompletions && props.formProxy.resource[platform].requiredStepCompletions.length) {
        for (let i = 0; i < props.formProxy.resource[platform].requiredStepCompletions.length; i++) {
            requiredStepIds.push(props.formProxy.resource[platform].requiredStepCompletions[i])
        }
      }
  }


  let deletedStepIds = requiredStepIds.filter((item) => {
    return !stepIds.includes(item)
  })

  deletedStepIds.forEach((id) => {
      stepOptions.push({value: id, text: id + ' (deleted step)'});
  })



  return <AutoSaveCheckboxOptionsBreakField {...props} options={stepOptions}/>
};

// class BreakStepCheckboxes extends React.Component {
//   getValueFromOnChange = (event, data) => {
//     return data.value;
//   };
//
//   get stepOptions() {
//     let steps = this.props.formProxy.currentBaseResource.steps;
//     let stepOptions = [];
//     if (!isNoU(steps)) {
//       for (var i = 0; i < steps.length; i++) {
//         let step = steps[i];
//         stepOptions.push({value: step.id, text: step.label ? step.label : step.type});
//       }
//     }
//     return stepOptions;
//   }
//
//   render() {
//     return (
//
//       <MultiPlatformField currentPlatform={this.props.currentPlatform}
//                           fieldConfig={{
//                             type: AutoSaveCheckboxOptions,
//                             name: this.props.name,
//                             label: this.props.label,
//                             labelKey: this.props.labelKey,
//                             helpContent: this.props.helpContent,
//                             helpHeader: this.props.helpHeader,
//                             validationRules: this.props.validationRules,
//                             required: this.props.required,
//                             options: this.stepOptions,
//                             sectionIndex: this.props.sectionIndex
//                           }}
//                           object={this.props.value}
//                           {...makeShared(this.props)}
//       />
//     );
//   }
// }

BreakStepCheckboxes.propTypes = {};

export default BreakStepCheckboxes;



// WEBPACK FOOTER //
// ./public/components/forms/CustomFields/BreakStepCheckboxes.jsx